export function fromNow(date: Date) {
  const now = new Date();
  const past = new Date(date);
  const locale = 'pt-BR';

  const nowBST = new Date(now.toUTCString()).setHours(now.getUTCHours() - 3);
  const pastBST = new Date(past.toUTCString()).setHours(past.getUTCHours() - 3);

  const diffInSeconds = Math.floor((pastBST - nowBST) / 1000);

  const units = [
    { unit: 'year', value: 31536000 },
    { unit: 'month', value: 2592000 },
    { unit: 'week', value: 604800 },
    { unit: 'day', value: 86400 },
    { unit: 'hour', value: 3600 },
    { unit: 'minute', value: 60 },
    { unit: 'second', value: 1 },
  ];

  for (const { unit, value } of units) {
    if (Math.abs(diffInSeconds) >= value) {
      const formatter = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
      return formatter.format(Math.round(diffInSeconds / value), unit as Intl.RelativeTimeFormatUnit);
    }
  }

  return 'Agora mesmo';
}
